export const coachWorkExceptionKeys = {
    all: ['coachWorkException'] as const,
    list: (centerId: string, year: string, month: string) =>
        [...coachWorkExceptionKeys.all, 'list', centerId, year, month] as const,
};
